import React from "react";
import PropTypes from "prop-types";
import className from "./style.module.scss";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import { connect } from "react-redux";
import { Image } from "@learningblocks/shared-components";

function ActivityComponent(props) {
  const { magnifications, content } = props;

  const highest = () => {
    const findHighest = magnifications.find((m) => m.value === "40x");
    if (findHighest?.image) {
      return (
        <Image
          style={{ borderRadius: "50%" }}
          width="300px"
          height="300px"
          src={findHighest.image}
        />
      );
    } else {
      return (
        <Image width="300px" height="300px" src={"images/sorter/Plate.svg"} />
      );
    }
  };

  return (
    <div className={className.activity}>
      <div className={className.activity__heading__wrapper}>
        <div className={className.activity__heading__wrapper_container}>
          <h5>Activity</h5>
        </div>
        <div className={className.activity__heading__wrapper_image}>
          {highest()}
        </div>
      </div>
      <div className={className.activity__content__container}>
        <p>
          <RichText text={content} />
        </p>
      </div>
    </div>
  );
}

ActivityComponent.propTypes = {
  image: PropTypes.string,
  heading: PropTypes.string,
  content: PropTypes.string,
  className: PropTypes.string,
  magnifications: PropTypes.array.isRequired,
};

ActivityComponent.defaultProps = {
  className: "activity",
};

const mapStateToProps = (state) => {
  const sorterState = state.sorter;

  return {
    magnifications: sorterState.magnifications,
  };
};

export const Activity = connect(mapStateToProps)(ActivityComponent);
